export default {
    body: {
        label: 'Leave your comment here ...',
        validation: 'Please enter a comment'
    },
    submit: 'Submit',
    reset: 'Cancel'
}
